import { apiHosts } from "@/api/constants/apiHosts";
import { ToastOptionsSuccess, type ToastOptionsError } from "@modernary/mui/components/toasts";
import { apiService, type Paging, type PagingApiAndNotifierConfig } from "@modernary/mui/utils/api";
import { serializeQueryParams } from "@modernary/mui/utils/helpers";
import type { DustMonitorCard, DustMonitorCardQuery, DustMonitorCardVeeUpdate } from "./dustMonitorCard";

const URL = "dust-monitor-cards";
const ENTITY_NAME = "Dust Monitor Card";

const axiosParams = {
  // Set different base URL based on the environment
  baseURL: import.meta.env.VITE_AQMS_API_BASE_URL,
};
const api = apiService<DustMonitorCard>(apiHosts.AQMS, axiosParams);

const getDustMonitorCards = (params: DustMonitorCardQuery, config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.hide = true;
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.fetched = ENTITY_NAME;
    config?.errorToastCb?.(options);
  };

  const url = config.pagingUrl ? config.pagingUrl : URL;

  return api.getPaged(url, {
    params,
    paramsSerializer: serializeQueryParams,
    abort: config?.abortMethod,
    successToastCb,
    errorToastCb,
  });
};

const getDustMonitorCardById = (id: string | number, config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.hide = true;
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.fetched = ENTITY_NAME;
    config?.errorToastCb?.(options);
  };

  return api.get(URL + "/" + id, { successToastCb, errorToastCb });
};

/** Cards still missing a VEE flag that were issued recently enough to be worth updating. */
const getPendingVeeDustMonitorCards = (config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.hide = true;
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.fetched = "Dust Monitor Cards";
    config?.errorToastCb?.(options);
  };

  return api.getPaged<Paging<DustMonitorCard>>(URL + "/pending-vee", { successToastCb, errorToastCb });
};

const updateDustMonitorCardsVee = (cards: DustMonitorCardVeeUpdate[], config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.updated = "VEE Status";
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.updated = "VEE Status";
    config?.errorToastCb?.(options);
  };

  return api.put(URL + "/vee", { cards }, { successToastCb, errorToastCb });
};

export { getDustMonitorCardById, getDustMonitorCards, getPendingVeeDustMonitorCards, updateDustMonitorCardsVee };
